/**
 * Check if user have roles
 * @param {array} roles
 * @param {array} userRoles
 * @returns
 */
export const checkUserHaveRoles = (roles, userRoles) => {
  if (!roles || !userRoles) return false
  return roles.some((role) => userRoles.map((userRole) => userRole.name).includes(role))
}

/**
 * Check if user has access to a module
 * @param {array} userRoles
 * @param {string} module
 * @returns {boolean}
 */
export const checkUserHaveSpecificRoles = (userRoles, module, roles_application_module) => {
  // Validar que se pasan los parámetros requeridos
  if (!userRoles || !module || !roles_application_module) return false

  // Verificar si alguno de los roles del usuario está en roles_application_module
  const hasAccess = userRoles.some((userRole) => {
    const roleModule = roles_application_module.find((role) => role.role === userRole.name)

    if (!roleModule) return false

    // Si el rol tiene acceso a todos los módulos
    if (roleModule.all) return true
    // Verificar si el módulo está en el array de módulos permitidos para el rol
    return roleModule.module.includes(module) || roleModule.moduleSub.includes(module)
  })

  return hasAccess
}
